import { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';

const Chart1 = () => {
    const chartRef = useRef<HTMLDivElement>(null);
    const chartInstance = useRef<ApexCharts | null>(null);

    useEffect(() => {
        if (!chartRef.current) return;

        const options = {
            series: [
                {
                    data: [
                        23, 32, 30, 27, 58, 33, 61, 28, 35, 47, 24, 29, 29, 45,
                        47, 63, 28, 55, 31, 36, 50, 19, 20, 37,
                    ],
                },
            ],
            chart: {
                type: 'area',
                height: 70,
                sparkline: {
                    enabled: true,
                },
                dropShadow: {
                    enabled: true,
                    enabledOnSeries: undefined,
                    top: 0,
                    left: 0,
                    blur: 3,
                    color: 'rgba(var(--primary-rgb))',
                    opacity: 0.4,
                },
            },
            stroke: {
                curve: 'smooth', // 곡선
                width: 1,
            },
            fill: {
                type: 'gradient',
                gradient: {
                    opacityFrom: 0.5,
                    opacityTo: 0.2,
                    stops: [0, 60],
                    colorStops: [
                        [
                            {
                                offset: 0,
                                color: 'rgba(var(--primary-rgb))',
                                opacity: 0.3,
                            },
                            {
                                offset: 60,
                                color: 'rgba(var(--primary-rgb))',
                                opacity: 0.2,
                            },
                        ],
                    ],
                },
            },
            colors: ['rgba(var(--primary-rgb))'],
            tooltip: {
                fixed: {
                    enabled: false,
                },
                x: {
                    show: false,
                },
                y: {
                    title: {
                        formatter: function () {
                            return '';
                        },
                    },
                },
            },
        };

        chartInstance.current = new ApexCharts(chartRef.current, options);
        chartInstance.current.render();

        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, []);

    return (
        <>
            <div className="card custom-card overflow-hidden">
                <div className="">
                    <div className="card-body">
                        <div className="d-flex align-items-center w-100 justify-content-between gap-1">
                            <div>
                                <p className="mb-1 text-muted fw-medium">
                                    작물온도
                                </p>
                                <h4 className="mb-0 fw-medium">
                                    <small className="fs-13">
                                        평균 31°C / 적산 2,331°C
                                    </small>
                                </h4>
                            </div>
                            <div className="ms-auto text-end">
                                <span className="badge bg-primary rounded-pill align-items-center fs-11">
                                    <i className="ri-arrow-left-up-line fs-11"></i>{' '}
                                    2.5%
                                </span>
                                <div className="text-muted fs-12 mt-1">
                                    지난주보다
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        ref={chartRef}
                        id="employees"
                        style={{
                            marginTop: -20,
                        }}
                    ></div>
                </div>
            </div>
        </>
    );
};

export default Chart1;
